import { useContext,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import ChangeAlert from '../components/ChangeAlert/ChangeAlert';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import SingleNotification from '../components/Notifications/SingleNotification';
import Sidebar from '../components/Sidebar/Sidebar';
import { UserContext } from '../context/UserContext';
import { trackEventMatomoVisit } from '../helpers/matomo';
import { HeaderText } from '../StyledComponents/pages/pages';
import { Container,SubContainer } from './Styles';

export default function TicketInPath() {
  const { changed } = useContext(UserContext);
  const { t } = useTranslation('translation');
  const idParam = useParams();
  const chamadoId = idParam?.id && idParam.id.includes("_-") ? idParam.id.split("_-")[0] : idParam.id;

  useEffect(() => {
    trackEventMatomoVisit('Visualizar chamado por link');
  }, []);

  return (
    <Container>
      <Sidebar />
      <SubContainer>
        {changed && <ChangeAlert />}
        <Header />
        <HeaderText style={{ textAlign: 'center' }}>{t('notifications.ticket.ticket')} {chamadoId ?? ''}</HeaderText>
        <div style={{
          marginBottom: '50px',
          padding: `${window.innerWidth < 800 ? '0px 2% 0px 2%' : '0px 10% 0px 10%'}`,
        }}>
          <SingleNotification />
        </div>
        <Footer />
      </SubContainer>
    </Container>
  );
}
